import { useEffect } from "react";
import { toast } from "~served/ui-comps/toast";
import { useGetCurrentVenue } from "~/queries/use-get-current-venue";
import { useIsReady } from "~/store";
import { isDevelopment } from "~served/utils/env";

export const TimezoneMismatchChecker = () => {
	const isReady = useIsReady();
	const { data: venueData } = useGetCurrentVenue();

	useEffect(() => {
		if (isReady && venueData?.timezone && isDevelopment()) {
			const venueTimezone = venueData.timezone;
			const deviceTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

			// Compare timezones (case-insensitive)
			if (venueTimezone.toLowerCase() !== deviceTimezone.toLowerCase()) {
				toast.warning(
					"Your device timezone doesn't match the venue's timezone. Some data might appear incorrectly.",
					{
						id: "timezone-mismatch",
					},
				);
			}
		} else {
			toast.dismiss("timezone-mismatch");
		}
	}, [venueData?.timezone, isReady]);

	return null;
};
